// IMP-057: Service status/statusType 문자열 상수
// Backend serviceConstants.js와 동일한 값 유지

export const SERVICE_STATUS = Object.freeze({
    NEW: 'New',
    REMOTE: 'Remote',
    VISIT: 'Visit',
    ESCALATE: 'Escalate',
    CLOSE: 'Close',
    OPEN: 'Open',   // status 필드의 "Open" 값 (ServiceList 토글 등에서 사용)
});

export const SERVICE_STATUS_TYPE = Object.freeze({
    OPEN: 'Open',   // statusType 필드: 서비스 열림/닫힘 구분
    CLOSE: 'Close',
});
